import { useAccount, useMsal } from "../components/common/msal";

export default function getAccountName(): string | null {

    const { accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    if (account && account.name) {
        return account.name;

    } else {
        return "";
    }
}




// WEBPACK FOOTER //
// ./ClientApp/utils/getAccountName.ts